import * as React from "react";

export interface IHomePageProps {}

export const HomePage: React.FunctionComponent<IHomePageProps> = (props) => {
  return <div/>;
};
